<!-- Loader -->
<div *ngIf="!isLoaded" class="w-full h-[360px] flex flex-col items-center justify-center gap-3">
  <div class="w-8 h-8 border-4 border-gray-300 border-t-gray-700 rounded-full animate-spin"></div>
  <span class="text-sm text-gray-400 font-medium">Engagement Rate</span>
</div>

<!-- Chart Content -->
<div class="relative w-full" *ngIf="isLoaded">

  <ng-container *ngIf="metricValue !== null && metricValue > 0; else noData">

    <!-- Header -->
    <div class="mb-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
      <h2 class="text-lg font-semibold tracking-tight text-gray-900">
        Engagement Rate
      </h2>

      <!-- Metric -->
      <div class="text-left sm:text-right">
        <p class="text-2xl font-bold text-gray-900">
          {{ metricValue | number }}
        </p>

        <p
          class="mt-1 flex items-center gap-1 text-sm font-medium sm:justify-end"
          [ngClass]="{
            'text-green-600': metricDiff > 0,
            'text-red-500': metricDiff < 0,
            'text-gray-500': metricDiff === 0
          }"
        >
          <span *ngIf="metricDiff > 0" class="text-base">↑</span>
          <span *ngIf="metricDiff < 0" class="text-base">↓</span>
          <span *ngIf="metricDiff === 0" class="text-gray-400">–</span>

          {{ metricDiff > 0 ? '' + (metricDiff | number) : (metricDiff | number) }}
          <span class="text-gray-400">vs. start</span>
        </p>
      </div>
    </div>

    <!-- Chart -->
    <apx-chart
      #chartRef
      [series]="chartOptions.series"
      [chart]="chartOptions.chart"
      [xaxis]="chartOptions.xaxis"
      [yaxis]="chartOptions.yaxis"
      [stroke]="chartOptions.stroke"
      [colors]="chartOptions.colors"
      [dataLabels]="chartOptions.dataLabels"
      class="w-full h-[360px] block"
    >
    </apx-chart>

  </ng-container>

  <!-- No Data -->
  <ng-template #noData>
    <div class="w-full h-[360px] grid place-items-center text-gray-500 relative rounded-2xl bg-gray-50">
      <img
        src="assets/images/charts-not-found.png"
        alt="No data available"
        class="absolute inset-0 w-full h-full object-contain opacity-80 select-none"
      />
    </div>
  </ng-template>

</div>